import Vue from "vue";
import Router from "vue-router";
// import Back from "../backHome/index";


// import Original from "../backHome/components/original";
// import Grounding from "../backHome/components/grounding";
// import Undercarriage from "../backHome/components/undercarriage";
// import Retrieve from "../backHome/components/retrieve";
// import Label from "../backHome/components/label";


import Back from "../backHome/index";


import login from "@/login";
import upload from "../upload";

//模型
import model from "../model";




//PS素材
import Material from "../material";
import Material_noe from "../material/components/Material_noe.vue";
import PSoriginal from "../material/components/PSoriginal";
import PSpeople from "../material/components/PSpeople";
import PS_Sky from "../material/components/PS_Sky";

//用户
import User from "../user";
import lits from "../user/components/lits";
import lits_dang from "../user/components/lits_dang";
import author from "../user/components/author";
import reference_author from "../user/components/reference_author"
import model_author from "../user/components/model_author"
import background from "../user/components/background";
import message from "../user/components/message";
import gongju from "../user/components/gongju";


//收入
import income from "../income";

import income_box from "../income/components/income_box";
import AI_income from "../income/components/AI_income";
import model_dang from "../income/components/model_dang";


import income_box_dang from "../income/components/income_box_dang";
import AI_income_dang from "../income/components/AI_income_dang";

import Label_quantity from "../Label_quantity";


//标签统计
import Reference_statistics from "../Label_quantity/components/Reference_statistics";
import Mode_statistics from "../Label_quantity/components/Mode_statistics";
import traffic_statistics from "../Label_quantity/components/traffic_statistics"

import Residence_statistics from "../Label_quantity/components/Residence_statistics"
import plant_statistics from "../Label_quantity/components/plant_statistics"
import scene_statistics from "../Label_quantity/components/scene_statistics"
import Pspeople_statistics from "../Label_quantity/components/Pspeople_statistics"
import PSplant_statistics from "../Label_quantity/components/PSplant_statistics"

import record from "../record";
import Search_Records from "../record/components/Search_Records";
import Search_Records_Dang from "../record/components/Search_Records_dang";

import Ai from "../AI";
import Search_ai from "../AI/components/ai";



//翻译

import translate from "../translate";
import translate_fanyi from "../translate/components/translate_fanyi";
import Classification from "../translate/components/Classification";
import Label_fanyi from "../translate/components/Label_fanyi";
import illustrate from "../translate/components/illustrate";



Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "后台",
            redirect: "/Back",
            component: Back,
            children: [
                 {
                    path: "/Back",
                    name: "参考图",
                    component: Back
                },
            ]
        },
        {
            path: "/model",
            name: "model",
            component: model,
            redirect: "/model",
            children: [
                {
                    path: "/model",
                    name: "室内场景",
                    component: model
                },
            ]
        },


        {
            path: "/material",
            name: "material",
            component: Material,
            redirect: "/Material_noe",
            children: [
                {
                    path: "/Material_noe",
                    name: "PS原始素材",
                    component: Material_noe
                },
                {
                    path: "/PSoriginal",
                    name: "PS人",
                    component: PSoriginal
                },
                {
                    path: "/PSpeople",
                    name: "PS植物",
                    component: PSpeople
                },
                {
                    path: "/PS_Sky",
                    name: "PS天空",
                    component: PS_Sky
                }

            ]
        },
        {
            path: "/user",
            name: "material",
            component: User,
            redirect: "/user/lits",
            children: [
                {
                    path: "/user/lits",
                    name: "用户列表",
                    component: lits
                },
                {
                    path: "/user/lits_dang",
                    name: "Ddang3d用户列表",
                    component: lits_dang
                },
                {
                    path: "/user/model_author",
                    name: "参考图作者",
                    component: model_author
                },
                {
                    path: "/user/reference_author",
                    name: "模型作者",
                    component: reference_author
                },
                {
                    path: "/user/background",
                    name: "后台用户",
                    component: background
                },
                {
                    path: "/user/message",
                    name: "站内信",
                    component: message
                },
                {
                    path: "/user/gongju",
                    name: "工具",
                    component: gongju
                },
            ]
        },

         {
            path: "/Label_quantity",
            name: "Label_quantity",
            component: Label_quantity,
            redirect: "Reference_statistics",
            children: [
                {
                    path: "/Reference_statistics",
                    name: "参考图标签",
                    component: Reference_statistics,
                },
                {
                    path: "/Mode_statistics",
                    name: "模型人标签",
                    component: Mode_statistics,
                },
                {
                    path: "/traffic_statistics",
                    name: "模型交通标签",
                    component: traffic_statistics,
                },
                ,
                {
                    path: "/Residence_statistics",
                    name: "模型家具标签",
                    component: Residence_statistics,
                },
                {
                    path: "/plant_statistics",
                    name: "模型家具标签",
                    component: plant_statistics,
                },
                {
                    path: "/scene_statistics",
                    name: "模型场景标签",
                    component: scene_statistics,
                },
                {
                    path: "/Pspeople_statistics",
                    name: "PS人标签",
                    component: Pspeople_statistics,
                },
                {
                    path: "/PSplant_statistics",
                    name: "PS人标签",
                    component: PSplant_statistics,
                }
            ]
        },


        {
            path: "/income",
            name: "income",
            component: income,
            redirect: "income_box",
            children: [
                {
                    path: "/income_box",
                    name: "3ddang收入",
                    component: income_box
                },{
                    path: "/AI_income",
                    name: "3ddang ai收入",
                    component: AI_income
                },{
                    path: "/model_dang",
                    name: "3ddang 模型收入",
                    component: model_dang
                },

                 {
                    path: "/income_box_dang",
                    name: "Dang3d收入",
                    component: income_box_dang
                },{
                    path: "/AI_income_dang",
                    name: "Dang3d ai收入",
                    component: AI_income_dang
                },
            ]
        },
          {
            path: "/record",
            name: "record",
            component: record,
            redirect: "Search_Records",
            children: [
                {
                    path: "/Search_Records",
                    name: "3ddang",
                    component: Search_Records,
                },
                  {
                    path: "/Search_Records_Dang",
                    name: "Dang3d",
                    component: Search_Records_Dang,
                },


            ]
        },
        {
            path: "/Ai",
            name: "Ai",
            component: Ai,
            redirect: "Search_ai",
            children: [
                {
                    path: "/Search_ai",
                    name: "ai",
                    component: Search_ai,
                },

            ]
        },
         {
            path: "/translate",
            name: "translate",
            component: translate,
            redirect: "translate_fanyi",
            children: [
                {
                    path: "/translate_fanyi",
                    name: "菜单",
                    component: translate_fanyi,
                },
                  {
                    path: "/Classification",
                    name: "分类",
                    component: Classification,
                },
                 {
                    path: "/Label_fanyi",
                    name: "分类",
                    component: Label_fanyi,
                },
                ,
                 {
                    path: "/illustrate",
                    name: "说明",
                    component: illustrate,
                },

            ]
        },


        {
            path: "/upload",
            name: "upload",
            component: upload
        },
        {
            path: "/login",
            name: "login",
            component: login,
            meta: { noLogin: true }
        }
    ]
});
router.beforeEach((to, from, next) => {
    let token = localStorage.getItem("token");
    if (to.meta.noLogin) {
        next();
    }
    if (!!token) {
        next();
        return;
    }
    next("/login");
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js